import _get from "lodash/get";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import nets from 'nets';
import qs from 'qs';
var api = "".concat(process.env.HOMEOWNERSHIP_BASE_URL, "/v1/geocoding/zip"); // eslint-disable-next-line func-names -- directive added automatically by Shepherd migration

export default function (zipCode) {
  return new Promise(function (resolve, reject) {
    return nets({
      url: "".concat(api, "?").concat(qs.stringify({
        zipCode: zipCode,
        client_id: process.env.CLIENT_ID
      })),
      json: true
    }, function (err, res, body) {
      if (err || _get(res, 'statusCode') >= 400) {
        reject(err);
        return;
      }

      resolve(_get(body, 'data[0]', {}));
    });
  });
}